import { KISTEN_VORGABEN, kistenText } from './kisten';

const MIN_QUANTITY = 1;
const MAX_QUANTITY = 20;

interface Props {
  quantity: number;
  onChange: (quantity: number) => void;
  /**
   * Die gewählte Kistenzahl, oder `undefined`, wenn in Stück gebucht wird. Der Bildschirm oben
   * hält sie, weil erst die Kachel den Artikel — und damit das Gebinde — kennt.
   */
  crates?: number;
  onCratesChange?: (crates: number | undefined) => void;
  /**
   * Nur an einem Entnahme-Event. Der Server sagt es über die Kiosk-Sitzung; hier wird es befolgt.
   */
  showCratePresets?: boolean;
}

/**
 * FR-64/AC-46: default 1, max 20. Left untouched, the default booking stays
 * exactly 1 (the ≤3-tap happy path, NFR-1) -- this control only matters when
 * a member wants to book a round of several identical drinks at once.
 */
export default function QuantityStepper({
  quantity,
  onChange,
  crates,
  onCratesChange,
  showCratePresets,
}: Props) {
  // Solange eine Kistenzahl gewählt ist, ist die Stückzahl nicht die Wahrheit -- sie steht erst
  // beim Antippen der Kachel fest. Den Stepper dann weiter eine „1" zeigen zu lassen, wäre die
  // Art von Anzeige, die man später für die gebuchte Menge hält.
  const inKisten = crates !== undefined;
  return (
    <div className="quantity-stepper">
      <span>Menge:</span>
      <button
        type="button"
        aria-label="Menge verringern"
        disabled={inKisten || quantity <= MIN_QUANTITY}
        onClick={() => onChange(Math.max(MIN_QUANTITY, quantity - 1))}
      >
        −
      </button>
      <span className="quantity-value">{inKisten ? '–' : quantity}</span>
      <button
        type="button"
        aria-label="Menge erhöhen"
        disabled={inKisten || quantity >= MAX_QUANTITY}
        onClick={() => onChange(Math.min(MAX_QUANTITY, quantity + 1))}
      >
        +
      </button>
      {showCratePresets &&
        KISTEN_VORGABEN.map((k) => (
          <button
            key={k}
            type="button"
            className="kiosk-preset-button"
            aria-pressed={crates === k}
            // Nochmal antippen hebt die Wahl auf -- sonst käme man ohne Umweg über eine Buchung
            // nicht mehr zurück ins Stückzählen.
            onClick={() => onCratesChange?.(crates === k ? undefined : k)}
          >
            {kistenText(k)}
          </button>
        ))}
    </div>
  );
}
